import React, { useState, useRef, useEffect } from "react";
import Image from 'next/image';
import PageStyle from "@/styles/components/dropzone/_index.module.scss";
import Button from "@/components/button";
import Deviceicon from 'public/icons/device.svg';
import Dropboxicon from 'public/icons/dropbox.svg';
import Driveicon from 'public/icons/drive.svg';
import { closeDropDown, DropboxChooser, GoogleChooser, EXTENSION_COMMON, onAddCandidateRemoveFile, onFileChange, onCancel, onRemoveFile, useRouter, useTranslation } from '@/imports-files/pages/career/view-job';
import {ButtonStyle} from '@/imports-files/common/common'


const DropZone = (props) => {
  const {t} =  useTranslation()
  const dropdownRef = useRef(null);
  const [isActive, setIsActive] = useState(false);
  const onClick = () => setIsActive(!isActive);
  const isAgency = props.isAgency || false
  const router = useRouter();

  useEffect(() => {
    let hash = { file_type: '', file: '', file_name: '' };

    // NOTE:- The dropbox is used in the agency client, client and job application 
    //        actionType is used for the edit agency client
    if (props?.formik && props?.formik?.values.client_candidate && props.actionType && props.actionType != 'edit') {
      props?.formik?.setFieldValue('client_candidate.resume_attributes', hash);
      props?.formik?.setFieldValue('client_candidate.other_files_attributes', []);
    }
  }, [])
  useEffect(() => {
    const pageClickEvent = (e) => {
      // If the active element exists and is clicked outside of
      if (dropdownRef.current !== null && !dropdownRef.current.contains(e.target)) {
        setIsActive(!isActive);
      }
    };

    // If the item is active (ie open) then listen for clicks
    if (isActive) {
      window.addEventListener('click', pageClickEvent);
    }

    return () => {
      window.removeEventListener('click', pageClickEvent);
    }

  }, [isActive]);

  const dragOver = (e) => {
    e.preventDefault();
  };

  const dragEnter = (e) => {
    e.preventDefault();
  };

  const dragLeave = (e) => {
    e.preventDefault();
  };

  const fileDrop = (e) => {
    e.preventDefault();
    const files = e.dataTransfer.files;
    if (files.length) {
      handleFiles(files);
    }
  };


  return (
    <>
      <div className={PageStyle.DropContainer}>
        <div className={PageStyle.DropContainer__Inner}
          onDragOver={dragOver}
          onDragEnter={dragEnter}
          onDragLeave={dragLeave}
          onDrop={(event) => {
            event.preventDefault();
            if (props.isDisabled)
              return false;
            else
              onFileChange(event.dataTransfer.files, props.formik, props.type, props.autofill, 'system', props.setCvErrorMessage, props.setOtherErrorMessage, props.setFileCount, props.setShowLoader, props.setIsDisabled)
          }}
        >
          <div className={PageStyle.DropContainer__Message}>
            <div className={PageStyle.DropContainer__UploadIcon}></div>
            {t('upload:drag_and_drop')}

            <div className={` BrowseFile ${PageStyle.Browse}`}>

              <Button buttonstyle={ButtonStyle.primarybtn} onClick={onClick} disabled={props.isDisabled}>
              {t('button:browse_to_upload')}
              </Button>

              <nav ref={dropdownRef} className={`dropboxmenu ${isActive ? 'active' : 'inactive'}`}>
                <ul>
                  <li onClick={() => closeDropDown(setIsActive)}>
                    <label htmlFor={props.id}>
                      <Deviceicon />  {t('upload:from_device')}
                    </label>
                    <input type="file"
                      multiple={props.multiple}
                      onChange={async(event) => {
                        await onFileChange(event.target.files, props.formik, props.type, props.autofill, 'system', props.setCvErrorMessage, props.setOtherErrorMessage, props.setFileCount, props.setShowLoader, props.setIsDisabled)
                        // If agency candidates we are auto enable my interview button
                        if(props.setWidgetReady && props.action){
                          props.setWidgetReady(props.action.setCandidateDetails(props.formRef.current?.values.client_candidate.first_name, props.formRef.current?.values.client_candidate.email))
                        }
                      }}
                      name="user_cv"
                      accept={props.accept}
                      id={props.id}
                    />
                  </li>

                  {/* TODO:- The router condition is used so that these li are not visible in the add candidates this logic will be replace*/}
                  {router.asPath.includes('/view-job') && <li onClick={() => closeDropDown(setIsActive)}>
                    <DropboxChooser
                      appKey={process.env.NEXT_PUBLIC_DROPBOX_API_KEY}
                      success={files => onFileChange(files, props.formik, props.type, props.autofill, 'dropbox', props.setCvErrorMessage, props.setOtherErrorMessage, props.setFileCount, props.setShowLoader, props.setIsDisabled)}
                      cancel={() => onCancel()}
                      multiselect={true}
                      extensions={props.extensions} >
                      <Dropboxicon />
                      <span> {t('upload:from_dropbox')}</span>
                    </DropboxChooser>
                  </li>}

                  {/* TODO:- The router condition is used so that these li are not visible in the add candidates this logic will be replace*/}
                  {router.asPath.includes('/view-job') && <li onClick={() => closeDropDown(setIsActive)}>
                    <GoogleChooser
                      clientId={process.env.NEXT_PUBLIC_GOOGLE_DRIVE_CLIENT_ID}
                      developerKey={process.env.NEXT_PUBLIC_GOOGLE_DRIVE_KEY}
                      success={files => onFileChange(files, props.formik, props.type, props.autofill, 'drive', props.setCvErrorMessage, props.setOtherErrorMessage, props.setFileCount, props.setShowLoader, props.setIsDisabled)}
                      multiselect={true}
                      navHidden={true}
                      authImmediate={false}
                      extensions={props.extensions}
                    >
                      <Driveicon />
                      <span>  {t('upload:from_drive')}</span>
                    </GoogleChooser>
                  </li>
                  }
                </ul>
              </nav>

            </div>
          </div>

        </div>


        <div className={PageStyle.FileDisplayContainer}>
          {

            props.formik.values?.job_application ? props.type == 'cv' ? (props.formik.values?.job_application?.resume_attributes?.file_name ?
              <div className={PageStyle.FileDisplayContainer__Status}>
                <span className={PageStyle.FileDisplayContainer__Name}>
                  {props.formik.values.job_application.resume_attributes.file_name}
                </span>
                <div className={PageStyle.FileDisplayContainer__Close}>
                  <Image src="/icons/close.png" height={13} width={13} alt="" onClick={() => onRemoveFile(props.formik, 'cv', 0, props.setCvErrorMessage, props.setOtherErrorMessage, props.setFileCount, props.setIsDisabled)} />
                </div>
              </div>
              : '')
              :
              (
                props.formik.values?.job_application?.job_application_files_attributes?.map((file, index) =>
                  <div className={PageStyle.FileDisplayContainer__Status} key={index}>
                    <span className={PageStyle.FileDisplayContainer__Name}>
                      {file.file_name}
                    </span>
                    <div className={PageStyle.FileDisplayContainer__Close}>
                      <Image src="/icons/close.png" height={13} width={13} alt="" onClick={() => onRemoveFile(props.formik, 'other', index, props.setCvErrorMessage, props.setOtherErrorMessage, props.setFileCount, props.setIsDisabled)} />
                    </div>
                  </div>
                )
              )
              :
              props.type == 'cv' ? (props.formik.values?.client_candidate?.resume_attributes?.file_name ?
                <div className={PageStyle.FileDisplayContainer__Status}>
                  <span className={PageStyle.FileDisplayContainer__Name}>
                    {props.formik.values.client_candidate.resume_attributes.file_name}
                  </span>
                  <div className={PageStyle.FileDisplayContainer__Close}>
                    <Image src="/icons/close.png" height={13} width={13} alt="" onClick={() => onAddCandidateRemoveFile(props.formik, 'cv', 0, props.setCvErrorMessage, props.setOtherErrorMessage, props.setFileCount, props.setIsDisabled, isAgency)} />
                  </div>
                </div>
                : '')
                :
                (
                  props.formik.values?.client_candidate?.other_files_attributes?.map((file, index) =>
                    (!file._destroy && <div className={PageStyle.FileDisplayContainer__Status} key={index}>
                      <span className={PageStyle.FileDisplayContainer__Name}>
                        {file.file_name}
                      </span>
                      <div className={PageStyle.FileDisplayContainer__Close}>
                        <Image src="/icons/close.png" height={13} width={13} alt="" onClick={() => onAddCandidateRemoveFile(props.formik, 'other', index, props.setCvErrorMessage, props.setOtherErrorMessage, props.setFileCount, props.setIsDisabled, isAgency)} />
                      </div>
                    </div>)
                  )
                )
          }
        </div>
      </div>
    </>
  );
};
export default DropZone;
